export const potentialDownload = [
  {
    id:1,
    name:'NCPP-PD04-PBE.zip',
    summary:'---New Release',
  },
  {
    id:2,
    name:'NCPP-PD04-PBE-SOC.zip',
    summary:'---New Release',
  },
  {
    id:3,
    name:'NCPP-FHI-LDA.zip',
    summary:'',
  },
  {
    id:4,
    name:'NCPP-PD03-PBE.zip',
    summary:'',
  },
  {
    id:5,
    name:'NCPP-SG15-LDA.zip',
    summary:'',
  },
  {
    id:6,
    name:'NCPP-SG15-PBE.zip',
    summary:'---recommend for accurate calculation',
  },
  {
    id:7,
    name:'NCPP-SG15-PBE-SOC.zip',
    summary:'---recommend for spin orbital coupling calculation\n',
  },
  {
    id:9,
    name:'ONCV-PWM-PBE.zip',
    summary:'',
  },
  {
    id:14,
    name:'H.zip',
    summary:'---分数氢',
  },
  {
    id:15,
    name:'GTH_BASIS_SETS.zip',
    summary:'',
  },
  {
    id:16,
    name:'BASIS_MOLOPT.zip',
    summary:'',
  },
  {
    id:17,
    name:'GTH_POTENTIALS.zip',
    summary:'',
  },
]


